export const isSSR = process.env.UIX_ENV == 'express'
